/** moderator/moderation — KEYS. */
export const moderationKeys = {
  all: () => ['moderator', 'moderation'] as const,
  /** Every match the game server runs (useModerationMatches). */
  matches: () => [...moderationKeys.all(), 'matches'] as const,
  /** A player's details, read when the moderator opens the player's card. */
  player: (customId: string) => [...moderationKeys.all(), 'player', customId] as const,
};
